// extracted by mini-css-extract-plugin
export default {"container":"xp-z","brandName":"yp-z","productName":"zp-z","productNamePdpEnhancements":"Ap-z","breakLongProductName":"Bp-z"};